<template>
  <div>
    <h1>Roles</h1>
    <div style="display: flex; gap: 1rem; margin-bottom: 1.5rem; align-items: flex-end; flex-wrap: wrap;">
      <div style="display: flex; gap: 0.5rem; align-items: flex-end;">
        <div>
          <label style="font-weight: 600;">Descripción</label>
          <input v-model="descripcion" placeholder="Buscar por descripción" @keyup.enter="fetchRoles" 
                 style="padding: 0.4rem; border-radius: 4px; width: 200px;" />
        </div>
        <button @click="fetchRoles" style="background: #007bff; color: white; border: none; padding: 0.5rem 1.2rem; border-radius: 4px; font-weight: 600;">🔍</button>
      </div>
      <button v-if="puedeAgregar" @click="abrirModalAgregar" style="background: #6c757d; color: white; border: none; padding: 0.5rem 1.2rem; border-radius: 4px; font-weight: 600;">+ Agregar Rol</button>
    </div>
    <div v-if="puedeMostrar" class="tabla-responsive">
      <table class="tabla-roles-principal">
      <thead>
        <tr style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white;">
          <th style="padding: 1rem;">Id</th>
          <th style="padding: 1rem;">Descripción</th>
          <th style="padding: 1rem;">Permisos</th>
          <th style="padding: 1rem;">Fecha Registro</th>
          <th style="padding: 1rem; text-align:center;">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="rol in roles" :key="rol.Id" style="border-bottom: 1px solid #e9ecef;">
          <td style="padding: 0.8rem; font-weight: 600;">{{ rol.Id }}</td>
          <td style="padding: 0.8rem;">{{ rol.Descripcion }}</td>
          <td style="padding: 0.8rem;">
            <ul style="margin:0;padding-left:1.2em;">
              <li v-for="permiso in rol.Permisos" :key="permiso.Id">{{ permiso.Descripcion }}</li>
            </ul>
          </td>
          <td style="padding: 0.8rem;">{{ formatFecha(rol.FechaRegistro) }}</td>
          <td style="padding: 0.8rem; text-align:center;">
            <button v-if="puedeModificar" @click="abrirModalEditar(rol)" style="background: #ffc107; color: #333; border: none; padding: 0.4rem 1rem; border-radius: 4px; margin-right: 0.5rem;">Editar</button>
            <button v-if="puedeEliminar" @click="eliminarRol(rol.Id)" style="background: #dc3545; color: white; border: none; padding: 0.4rem 1rem; border-radius: 4px;">Eliminar</button>
          </td>
        </tr>
        <tr v-if="roles.length === 0">
          <td colspan="5" style="text-align:center; padding: 2rem; color: #6c757d; font-style: italic;">No hay roles registrados</td>
        </tr>
      </tbody>
      </table>
    </div>
    <div v-if="!puedeMostrar" style="text-align:center; color:#d32f2f; margin:2rem 0;">No tienes permiso para ver la lista de roles.</div>
    <div style="margin-top:1rem;">
      <button :disabled="page === 1" @click="cambiarPagina(page-1)">Anterior</button>
      Página {{ page }} de {{ totalPages }}
      <button :disabled="page === totalPages" @click="cambiarPagina(page+1)">Siguiente</button>
    </div>

    <!-- Modal Editar -->
    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Editar Rol</h3>
          <button class="close-btn" @click="cerrarModalEditar">&times;</button>
        </div>
        <label>Descripción
          <input v-model="rolEditar.Descripcion" />
        </label>
        <div style="margin-top:1rem;">
          <strong>Permisos:</strong>
          <div class="permisos-container">
            <div v-for="(permisosUrl, url) in permisosAgrupados" :key="url" class="grupo-permisos">
              <div @click="toggleGrupo(url)" class="grupo-header">
                <span v-if="gruposExpand[url]">▼</span><span v-else>▶</span>
                {{ url.replace(/^\//, '') }}
              </div>
              <div v-show="gruposExpand[url]" class="permisos-lista">
                <div v-for="permiso in permisosUrl" :key="permiso.Id" class="permiso-item">
                  <input type="checkbox" :value="permiso.Id" v-model="rolEditar.PermisosSeleccionados" />
                  <span>{{ permiso.Descripcion }}</span>
                  <span v-if="permiso.Activo === false" class="permiso-inactivo">(Inactivo)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-buttons">
          <button class="btn-primary" @click="guardarEdicion">Guardar</button>
          <button class="btn-secondary" @click="cerrarModalEditar">Cancelar</button>
        </div>
      </div>
    </div>

    <!-- Modal Agregar -->
    <div v-if="showModalAgregar" class="modal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Agregar Rol</h3>
          <button class="close-btn" @click="cerrarModalAgregar">&times;</button>
        </div>
        <label>Descripción
          <input v-model="rolNuevo.Descripcion" />
        </label>
        <div style="margin-top:1rem;">
          <strong>Permisos:</strong>
          <div class="permisos-container">
            <div v-for="(permisosUrl, url) in permisosAgrupados" :key="url" class="grupo-permisos">
              <div @click="toggleGrupo(url)" class="grupo-header">
                <span v-if="gruposExpand[url]">▼</span><span v-else>▶</span>
                {{ url.replace(/^\//, '') }}
              </div>
              <div v-show="gruposExpand[url]" class="permisos-lista">
                <div v-for="permiso in permisosUrl" :key="permiso.Id" class="permiso-item">
                  <input type="checkbox" :value="permiso.Id" v-model="rolNuevo.PermisosSeleccionados" />
                  <span>{{ permiso.Descripcion }}</span>
                  <span v-if="permiso.Activo === false" class="permiso-inactivo">(Inactivo)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-buttons">
          <button class="btn-primary" @click="guardarNuevo">Agregar</button>
          <button class="btn-secondary" @click="cerrarModalAgregar">Cancelar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* === ESTILOS RESPONSIVE PARA MODALES DE ROLES === */

/* Modal overlay */
.modal {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  background: rgba(0, 0, 0, 0.6) !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  z-index: 1000 !important;
  padding: 1rem !important;
  backdrop-filter: blur(2px);
  box-sizing: border-box !important;
}

/* Contenido del modal */
.modal-content {
  background: white !important;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  width: 100% !important;
  max-width: 600px !important;
  min-width: 300px !important;
  max-height: 85vh !important;
  overflow-y: auto;
  position: relative;
  animation: modalSlideIn 0.3s ease-out;
  margin: 0 auto !important;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Header del modal */
.modal-content h3 {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  margin: 0;
  padding: 1.5rem;
  border-radius: 12px 12px 0 0;
  font-size: 1.2rem;
  font-weight: 600;
  text-align: center;
}

/* Contenido interno */
.modal-content > div,
.modal-content > label {
  padding: 0 1.5rem;
}

.modal-content > button {
  margin: 1.5rem;
}

/* Labels y inputs */
.modal-content label {
  display: block;
  margin: 1rem 0;
  font-weight: 600;
  color: #333;
}

.modal-content input[type="text"] {
  width: 100%;
  padding: 0.8rem;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 1rem;
  margin-top: 0.5rem;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.modal-content input[type="text"]:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* Container de permisos */
.permisos-container {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  background: #f8f9fa;
  margin-top: 0.5rem;
}

/* Scroll personalizado */
.permisos-container::-webkit-scrollbar {
  width: 6px;
}

.permisos-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.permisos-container::-webkit-scrollbar-thumb {
  background: #667eea;
  border-radius: 3px;
}

/* Grupos de permisos */
.grupo-permisos {
  border-bottom: 1px solid #e1e5e9;
}

.grupo-permisos:last-child {
  border-bottom: none;
}

.grupo-header {
  padding: 0.8rem 1rem;
  background: white;
  cursor: pointer;
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: background-color 0.2s;
}

.grupo-header:hover {
  background: #e9ecef;
}

.grupo-header span:first-child {
  font-size: 0.8rem;
  color: #667eea;
  font-weight: bold;
}

/* Lista de permisos */
.permisos-lista {
  padding: 0.5rem 1rem 0.5rem 2rem;
  background: #fff;
}

.permiso-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0;
  border-bottom: 1px solid #f1f3f4;
}

.permiso-item:last-child {
  border-bottom: none;
}

.permiso-item input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #667eea;
}

.permiso-item span {
  flex: 1;
  font-size: 0.9rem;
  color: #495057;
}

.permiso-inactivo {
  color: #dc3545 !important;
  font-size: 0.8rem !important;
  font-style: italic;
}

/* Botones */
.modal-content button {
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s;
  margin-right: 0.5rem;
}

.modal-content button:first-of-type {
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
}

.modal-content button:first-of-type:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.modal-content button:last-of-type {
  background: #6c757d;
  color: white;
}

.modal-content button:last-of-type:hover {
  background: #5a6268;
}

/* Responsive Design */
@media (max-width: 768px) {
  .modal {
    padding: 0.5rem !important;
    align-items: flex-start !important;
    padding-top: 2rem !important;
  }
  
  .modal-content {
    max-width: 100% !important;
    width: calc(100% - 1rem) !important;
    max-height: 90vh !important;
    border-radius: 8px;
  }
  
  .modal-content h3 {
    padding: 1rem;
    font-size: 1.1rem;
    border-radius: 8px 8px 0 0;
  }
  
  .modal-content > div,
  .modal-content > label {
    padding: 0 1rem;
  }
  
  .modal-content > button {
    margin: 1rem;
  }
  
  .permisos-container {
    max-height: 250px;
  }
  
  .grupo-header {
    padding: 0.6rem;
    font-size: 0.9rem;
  }
  
  .permiso-item {
    padding: 0.3rem 0;
  }
  
  .modal-content button {
    padding: 0.7rem 1.2rem;
    font-size: 0.85rem;
    width: 100%;
    margin: 0.3rem 0;
  }
}

@media (max-width: 480px) {
  .modal {
    padding: 0.25rem !important;
    align-items: flex-start !important;
    padding-top: 1rem !important;
  }
  
  .modal-content {
    width: calc(100% - 0.5rem) !important;
    max-width: 100% !important;
    max-height: 95vh !important;
    margin: 0 !important;
  }
  
  .modal-content h3 {
    font-size: 1rem;
    padding: 0.8rem;
  }
  
  .permisos-container {
    max-height: 200px;
  }
  
  .modal-content input[type="text"] {
    padding: 0.6rem;
    font-size: 0.9rem;
  }
}

/* Extra small devices */
@media (max-width: 360px) {
  .modal {
    padding: 0.1rem !important;
  }
  
  .modal-content {
    width: calc(100% - 0.2rem) !important;
    border-radius: 4px;
  }
  
  .modal-content h3 {
    font-size: 0.9rem;
    padding: 0.6rem;
  }
  
  .modal-content > div,
  .modal-content > label {
    padding: 0 0.8rem;
  }
}

/* Asegurar que el modal no se vea afectado por otros estilos */
.modal * {
  box-sizing: border-box !important;
}

/* Mejoras para accesibilidad */
@media (prefers-reduced-motion: reduce) {
  .modal-content {
    animation: none;
  }
  
  .modal-content button,
  .grupo-header {
    transition: none;
  }
}
</style>

<script>
import { apiFetch } from '../restapi.js';

export default {
  name: 'RolesView',
  data() {
    // Leer permisos de localStorage
    let permisosRoles = [];
    try {
      const permisos = JSON.parse(localStorage.getItem('permisos') || '{}');
      permisosRoles = permisos['/roles'] || [];
    } catch (e) {}
    return {
      roles: [],
      total: 0,
      page: 1,
      pageSize: 10,
      descripcion: '',
      showModal: false,
      showModalAgregar: false,
      rolEditar: null,
      rolNuevo: {
        Descripcion: '',
        PermisosSeleccionados: []
      },
      permisos: [],
      permisosRoles,
      permisosAgrupados: {},
      gruposExpand: {}
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize) || 1;
    },
    puedeMostrar() {
      return this.permisosRoles.some(p => p.Descripcion === 'Mostrar Lista Roles');
    },
    puedeAgregar() {
      return this.permisosRoles.some(p => p.Descripcion === 'Agregar Roles');
    },
    puedeModificar() {
      return this.permisosRoles.some(p => p.Descripcion === 'Modificar Roles');
    },
    puedeEliminar() {
      return this.permisosRoles.some(p => p.Descripcion === 'Eliminar Roles');
    }
  },
  methods: {
    async fetchPermisos() {
      try {
        const response = await apiFetch('/permisos/ObtenerListaPermisos', {
          headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        const data = await response.json();
        this.permisosAgrupados = data; // objeto agrupado por URL
        this.permisos = Object.values(data).flat();
        // Inicializar todos los grupos expandidos por defecto
        this.gruposExpand = {};
        Object.keys(data).forEach(url => {
          this.$set(this.gruposExpand, url, true);
        });
      } catch (err) {
        this.permisos = [];
        this.permisosAgrupados = {};
        this.gruposExpand = {};
        if (this.$toast) this.$toast.error('Error al obtener permisos');
      }
    },
    async fetchRoles() {
      const params = `?descripcion=${encodeURIComponent(this.descripcion)}&page=${this.page}&pageSize=${this.pageSize}`;
      try {
        const response = await apiFetch(`/roles/ObtenerRolesPaginados${params}`, {
          headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        const data = await response.json();
        this.roles = (data.roles || []).map(r => ({ ...r, Permisos: r.Permisos || [] }));
        this.total = data.total || 0;
      } catch (err) {
  this.roles = [];
  this.total = 0;
  if (this.$toast) this.$toast.error('Error al obtener roles');
      }
    },
    abrirModalEditar(rol) {
      this.rolEditar = {
        Id: rol.Id,
        Descripcion: rol.Descripcion,
        PermisosSeleccionados: (rol.Permisos || []).map(p => p.Id)
      };
      this.showModal = true;
      this.fetchPermisos();
    },
    cerrarModalEditar() {
      this.showModal = false;
      this.rolEditar = null;
    },
    async guardarEdicion() {
      if (!this.rolEditar) return;
      try {
        const response = await apiFetch(`/roles/ModificarRol/${this.rolEditar.Id}`, {
          method: 'PATCH',
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({
            Descripcion: this.rolEditar.Descripcion,
            Permisos: this.rolEditar.PermisosSeleccionados.filter(Boolean)
          })
        });
        if (!response.ok) throw new Error('Error al editar rol');
        const data = await response.json();
        this.cerrarModalEditar();
        this.fetchRoles();
  if (this.$toast) this.$toast.success(data.message || 'Rol editado correctamente');
      } catch (err) {
  if (this.$toast) this.$toast.error('Error al editar rol');
      }
    },
    async eliminarRol(id) {
      if (confirm('¿Seguro que deseas eliminar este rol?')) {
        try {
          const response = await apiFetch(`/roles/EliminarRol/${id}`, {
            method: 'DELETE',
            headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
          });
          if (!response.ok) throw new Error('Error al eliminar rol');
          const data = await response.json();
          this.fetchRoles();
          if (this.$toast) this.$toast.success(data.message || 'Rol eliminado correctamente');
        } catch (err) {
          if (this.$toast) this.$toast.error('Error al eliminar rol');
        }
      }
    },
    abrirModalAgregar() {
      this.rolNuevo = { Descripcion: '', PermisosSeleccionados: [] };
      this.showModalAgregar = true;
      this.fetchPermisos();
    },
    cerrarModalAgregar() {
      this.showModalAgregar = false;
    },
    async guardarNuevo() {
      try {
        const response = await apiFetch('/roles/AgregarRol', {
          method: 'POST',
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({
            Descripcion: this.rolNuevo.Descripcion,
            Permisos: this.rolNuevo.PermisosSeleccionados.filter(Boolean)
          })
        });
        if (!response.ok) throw new Error('Error al agregar rol');
        const data = await response.json();
        this.cerrarModalAgregar();
        this.fetchRoles();
  if (this.$toast) this.$toast.success(data.message || 'Rol agregado correctamente');
      } catch (err) {
  if (this.$toast) this.$toast.error('Error al agregar rol');
      }
    },
    cambiarPagina(nuevaPagina) {
      this.page = nuevaPagina;
      this.fetchRoles();
    },
    formatFecha(fecha) {
      if (!fecha) return '';
      // Para fechas que incluyen hora, mantenemos el comportamiento original
      // ya que probablemente necesitamos mostrar la hora también
      return new Date(fecha).toLocaleString();
    },
    toggleGrupo(url) {
      this.$set(this.gruposExpand, url, !this.gruposExpand[url]);
    }
  },
  mounted() {
    this.fetchRoles();
    // Configurar scroll horizontal
    this.$nextTick(() => {
      const tabla = document.querySelector('.tabla-responsive');
      if (tabla) {
        tabla.addEventListener('wheel', (e) => { if (tabla.scrollWidth > tabla.clientWidth) { e.preventDefault(); tabla.scrollLeft += e.deltaY; } }, { passive: false });
        let isDown = false, startX, scrollLeft;
        tabla.addEventListener('mousedown', (e) => { isDown = true; startX = e.pageX - tabla.offsetLeft; scrollLeft = tabla.scrollLeft; tabla.style.cursor = 'grabbing'; });
        tabla.addEventListener('mouseleave', () => { isDown = false; tabla.style.cursor = 'grab'; });
        tabla.addEventListener('mouseup', () => { isDown = false; tabla.style.cursor = 'grab'; });
        tabla.addEventListener('mousemove', (e) => { if (!isDown) return; e.preventDefault(); const x = e.pageX - tabla.offsetLeft; tabla.scrollLeft = scrollLeft - (x - startX) * 2; });
      }
    });
  }
};
</script>

<style scoped>
/* --- TABLA RESPONSIVA --- */
.tabla-responsive {
  width: 100% !important; overflow-x: auto !important; overflow-y: hidden !important;
  -webkit-overflow-scrolling: touch; margin-bottom: 1.5rem; box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border-radius: 8px; max-width: 100vw !important; display: block !important; position: relative;
  scrollbar-width: auto; scrollbar-color: #4a90e2 #e0e0e0; cursor: grab;
}
.tabla-responsive:active { cursor: grabbing; }
.tabla-responsive::-webkit-scrollbar { height: 12px; }
.tabla-responsive::-webkit-scrollbar-track { background: #e0e0e0; border-radius: 6px; }
.tabla-responsive::-webkit-scrollbar-thumb { background: #4a90e2; border-radius: 6px; }
.tabla-responsive::after { content: "← Desplázate horizontalmente →"; position: absolute; bottom: -25px; left: 50%; transform: translateX(-50%); font-size: 12px; color: #666; opacity: 0.7; }
@media (min-width: 1201px) { .tabla-responsive::after { display: none; } }
.tabla-roles-principal { width: 900px !important; min-width: 900px !important; table-layout: fixed !important; }
.modal {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-content {
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  min-width: 800px;
  max-width: 95vw;
  max-height: 90vh;
  overflow-y: auto;
}
.modal-content label {
  display: block;
  margin-top: 1rem;
}
.modal-content input {
  width: 100%;
  padding: 0.5rem;
  margin-top: 0.2rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.modal-content button {
  margin-top: 1.2rem;
}

.permisos-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-top: 1rem;
}

.grupo-permisos {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 1rem;
  background-color: #fafafa;
}

.grupo-header {
  font-size: 0.95em;
  color: #1976d2;
  margin-bottom: 0.5rem;
  cursor: pointer;
  user-select: none;
  font-weight: 600;
  padding: 0.3rem;
  background-color: #e3f2fd;
  border-radius: 4px;
}

.grupo-header:hover {
  background-color: #bbdefb;
}

.permisos-lista {
  margin-left: 0.5rem;
  display: grid;
  gap: 0.3rem;
}

.permiso-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.2rem;
  font-size: 0.9rem;
}

.permiso-item input[type="checkbox"] {
  width: auto;
  margin: 0;
}

.permiso-inactivo {
  color: #d32f2f;
  font-size: 0.8rem;
  font-style: italic;
}

/* Estilos para el header del modal */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.5rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid #e1e5e9;
  padding-bottom: 1rem;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #333;
}

/* Botón de cerrar (X) */
.close-btn {
  background: none;
  border: none;
  font-size: 1.1rem;
  font-weight: bold;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

/* Responsivo para el botón de cerrar */
@media (max-width: 768px) {
  .close-btn {
    width: 20px;
    height: 20px;
    font-size: 0.95rem;
  }
}

@media (max-width: 480px) {
  .close-btn {
    width: 18px;
    height: 18px;
    font-size: 0.9rem;
  }
}

.close-btn:hover {
  background-color: #f5f5f5;
  color: #666;
}

.close-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.3);
}

/* Container para botones del modal */
.modal-buttons {
  display: flex;
  gap: 0.75rem;
  padding: 1.5rem;
  border-top: 1px solid #e1e5e9;
  background-color: #f8f9fa;
  margin-top: 1.5rem;
  justify-content: flex-end;
}

/* Botones estandarizados */
.btn-primary {
  background: #6c757d;
  color: white;
  border: none;
  padding: 0.5rem 1.2rem;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 0.9rem;
}

.btn-primary:hover {
  background: #5a6268;
}

.btn-primary:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(108, 117, 125, 0.3);
}

.btn-secondary {
  background: #e9ecef;
  color: #495057;
  border: 1px solid #ced4da;
  padding: 0.5rem 1.2rem;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;
}

.btn-secondary:hover {
  background: #dee2e6;
  border-color: #adb5bd;
}

.btn-secondary:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(108, 117, 125, 0.15);
}
</style>
